import { useState, useRef } from 'react'

export function useIframeVisibilityState() {
  const [isPayInOpen, setPayInOpen] = useState(false)
  const closeHandlerRef = useRef<(() => void) | undefined>(undefined)
  return { isPayInOpen, setPayInOpen, closeHandlerRef }
}
